import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsHelpRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-help',
	path: '/secure/InsertCollectorHelp([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
